var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11.15 11.15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43411 1.39062H3.71745C2.43454 1.39062 1.39453 2.43063 1.39453 3.71354V7.43021C1.39453 8.71312 2.43454 9.75313 3.71745 9.75313H7.43411C8.71703 9.75313 9.75703 8.71312 9.75703 7.43021V3.71354C9.75703 2.43063 8.71703 1.39062 7.43411 1.39062Z",
    stroke: "white",
    strokeWidth: 0.975625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57443 7.29729C6.52378 7.29729 7.29339 6.52769 7.29339 5.57833C7.29339 4.62898 6.52378 3.85938 5.57443 3.85938C4.62507 3.85938 3.85547 4.62898 3.85547 5.57833C3.85547 6.52769 4.62507 7.29729 5.57443 7.29729Z",
    stroke: "white",
    strokeWidth: 0.975625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03939 3.5319C8.2704 3.5319 8.45768 3.34462 8.45768 3.11361C8.45768 2.88259 8.2704 2.69531 8.03939 2.69531C7.80837 2.69531 7.62109 2.88259 7.62109 3.11361C7.62109 3.34462 7.80837 3.5319 8.03939 3.5319Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.c55b54dad83edd70571c0935b8d99fe9.svg";
export { ForwardRef as ReactComponent };